import { sanitiseUrl } from '../utils/url-validator';
import { parseApiKey } from '../utils/api-key-parser';
import ApiClient from './../api-client';

type Config = {
  workspaceId: string;
  tenantId?: string;
};

class SDKInstanceManager {
  private static instance: SDKInstanceManager;
  private isInitialised: boolean = false;
  private config: Config = { workspaceId: '' };
  private apiClient?: ApiClient;

  constructor() {
    if (!SDKInstanceManager.instance) {
      this.config = { workspaceId: '' };
      this.isInitialised = false;
      SDKInstanceManager.instance = this;
    }

    return SDKInstanceManager.instance;
  }

  /**
   * @param options.baseUrl - e.g. http://localhost:8080 — uses local API path/shape; omit for legacy Gateway URL from the key.
   */
  initialise(apiKey: string, options?: { baseUrl?: string }) {
    if (this.getIsInitialised()) {
      console.info('SDK is already initialised with API key');
      return;
    }
    if (!apiKey || typeof apiKey !== 'string') {
      throw new Error('SDK needs a valid API key to be initialised');
    }

    // Parse the API key to extract workspaceId, tenantId, and baseUrl for SDK configuration
    // The original unparsed API key will be sent to the API
    const parsed = parseApiKey(apiKey);
    const override = options?.baseUrl?.trim();
    const useMonolith = override != null && override.length > 0;

    this.config = {
      workspaceId: parsed.workspaceId,
      tenantId: parsed.tenantId,
    };

    const base = useMonolith ? override! : parsed.baseUrl;
    const sanitisedUrl = sanitiseUrl(base);
    this.apiClient = new ApiClient({
      apiKey,
      baseUrl: sanitisedUrl,
      config: this.config,
      useMonolith,
    });
    this.isInitialised = true;
  }

  destroy() {
    this.config = { workspaceId: '' };
    this.isInitialised = false;
  }

  getIsInitialised() {
    return this.isInitialised;
  }

  getApiClient() {
    return this.apiClient;
  }

  getConfig() {
    return this.config;
  }
}

const instance = new SDKInstanceManager();
export { instance as default };
